import { removeUndefinedFields } from "../helper";

export const QUESTIONS = [
  {
    label: "In Radiator is filled with",
    options: [
      { label: "Coolant", apiOptionKey: "collant" },
      {
        label: "Water",
        apiOptionKey: "water",
      },
      {
        label: "Photos",
        type: "FILE",
        apiOptionKey: "attachments",
      },
    ],
  },

  {
    label: "Coolant Information",
    options: [
      {
        label: "Coolant make",
        type: "INPUT",
        apiOptionKey: "collantmake",
      },
      {
        label: "Coolant PH value",
        type: "INPUT",
        apiOptionKey: "coolantPHValue",
        keyboardType: "numeric",
      },
      {
        label: "% of coolant / Additive with respect to RO water",
        type: "INPUT",
        apiOptionKey: "percentOfCoolantOrAdditiveWithRespectToROWater",
        keyboardType: "numeric",
      },
    ],
  },

  {
    label: "Coolant level observed in recovery tank",
    type: "RADIO",
    apiKey: "coolantLevelObservedInRecoveryTank",
    options: [
      {
        label: "UPTO_MAX_MARK",
        apiOptionKey: "foundAirInFuelSystem",
      },
      {
        label: "UPTO_MIN_MARK",
        apiOptionKey: "foundLowPressurePipeBlocked",
      },
      {
        label: "BETWEEN_MIN_AND_MAX_MARK",
        apiOptionKey: "foundLowpressurePipeBend",
      },
      {
        label: "NO_COOLANT",
        apiOptionKey: "foundFuelHoseBanjoWasherDamage",
      },
    ],
  },
  {
    label: "Coolant level in Radiator",
    apiKey: "coolantLevelInRadiator",
    type: "RADIO",
    options: [
      { label: "UPTO_NECK", apiOptionKey: "UPTO_NECK" },
      { label: "SLIGHTLY_BELOW_NECK", apiOptionKey: "SLIGHTLY_BELOW_NECK" },
      { label: "NO_COOLANT", apiOptionKey: "NO_COOLANT" },
    ],
  },
  {
    label: "Radiator condition",
    options: [
      { label: "Found Good", apiOptionKey: "foundGood" },
      { label: "Found Fins damaged", apiOptionKey: "foundFinsDamaged" },
      { label: "Found Fins clogged", apiOptionKey: "foundFinsClogged" },
      { label: "Found core leakage", apiOptionKey: "foundCoreLeakage" },
      { label: "Found muddy in core", apiOptionKey: "foundMuddyInCore" },
    ],
  },
  {
    label: "Coolant Temperature in OC",
    type: "INPUT",
    apiKey: "coolantTempratureInOC",
    keyboardType: "numeric",
    options: [],
  },
  {
    label: "Thermostat Condition",
    options: [
      { label: "Found ok", apiOptionKey: "q7o1" },
      { label: "Found struck open", apiOptionKey: "foundStruckOpen" },
      { label: "Found struck closed", apiOptionKey: "foundStruckClosed" },
      {
        label: "Physical damage observed",
        apiOptionKey: "physicalDamageObserved",
      },
      {
        label: "Discoloration observed",
        apiOptionKey: "discolorationObserved",
      },
      {
        label: "Opening Temperature in OC",
        apiOptionKey: "openingTempratureInOc",
        keyboardType: "numeric",
        type: "INPUT",
      },
    ],
  },
  {
    label: "Water Pump condition",
    options: [
      { label: "Found ok", apiOptionKey: "q8o1" },
      {
        label: "Found Coolant leakage from weep hole",
        apiOptionKey: "foundCoolantLeakageFromWeepHole",
      },
      {
        label: "Found casting blockage",
        apiOptionKey: "foundCastingBlockage",
      },
    ],
  },
  {
    label: "Coolant hose condition",
    options: [
      { label: "Found ok", apiOptionKey: "q9o1" },
      {
        label: "Found puncture / damage",
        apiOptionKey: "foundPunctureOrDamage",
      },
      { label: "Found blockage", apiOptionKey: "foundBlockage" },
      { label: "Found Clamping loose", apiOptionKey: "foundClampingLoose" },
    ],
  },
  {
    label: "Coolant Flow",
    options: [
      { label: "Free flow observed", apiOptionKey: "freeFlowObserved" },
      {
        label: "Casting blockage in Inlet connection",
        apiOptionKey: "castingBlockageInInletConnection",
      },
      {
        label: "Casting blockage in Cylinder block",
        apiOptionKey: "castingBlockageInCylinderBlock",
      },
    ],
  },
  {
    label: "Condition of Fan belt",
    options: [
      { label: "Found 10 mm deflection", apiOptionKey: "foundTenMMDeflection" },
      { label: "Found very tight", apiOptionKey: "foundVeryTight" },
      { label: "Found loose fitted", apiOptionKey: "foundLoseFitted" },
    ],
  },
  {
    label: "Condition of Radiator Pressure Cap",
    options: [
      { label: "Found OK", apiOptionKey: "q1001" },
      { label: "Found Missing", apiOptionKey: "foundMissing" },
      { label: "Found faulty", apiOptionKey: "foundFaulty" },
    ],
  },
];

export const mappingDetailsToUICoolantCondition = (details) => {
  const {
    inRadiatorIsFilledWith = {},
    radiatorCondition = {},
    thermostatCondition = {},
    waterPumpCondition = {},
    coolantHoseCondition = {},
    coolantFlow = {},
    conditionOfFanBelt = {},
    conditionOfRadiatorPressureCap = {},
  } = details;

  let responseDetails = {
    collant: inRadiatorIsFilledWith.collant,
    water: inRadiatorIsFilledWith.water,

    collantmake: details?.collantmake,
    coolantPHValue: details?.coolantPHValue,
    percentOfCoolantOrAdditiveWithRespectToROWater:
      details?.percentOfCoolantOrAdditiveWithRespectToROWater,

    coolantLevelObservedInRecoveryTank:
      details?.coolantLevelObservedInRecoveryTank,
    coolantLevelInRadiator: details?.coolantLevelInRadiator,

    foundGood: radiatorCondition.foundGood,
    foundFinsDamaged: radiatorCondition.foundFinsDamaged,
    foundFinsClogged: radiatorCondition.foundFinsClogged,
    foundCoreLeakage: radiatorCondition.foundCoreLeakage,
    foundMuddyInCore: radiatorCondition.foundMuddyInCore,

    coolantTempratureInOC: details?.coolantTempratureInOC?.toString(),

    q7o1: thermostatCondition.foundOk,
    foundStruckOpen: thermostatCondition.foundStruckOpen,
    foundStruckClosed: thermostatCondition.foundStruckClosed,
    physicalDamageObserved: thermostatCondition.physicalDamageObserved,
    discolorationObserved: thermostatCondition.discolorationObserved,
    openingTempratureInOc:
      thermostatCondition.openingTempratureInOc?.toString(),

    q8o1: waterPumpCondition.foundOk,
    foundCoolantLeakageFromWeepHole:
      waterPumpCondition.foundCoolantLeakageFromWeepHole,
    foundCastingBlockage: waterPumpCondition.foundCastingBlockage,

    q9o1: coolantHoseCondition.foundOk,
    foundPunctureOrDamage: coolantHoseCondition.foundPunctureOrDamage,
    foundBlockage: coolantHoseCondition.foundBlockage,
    foundClampingLoose: coolantHoseCondition.foundClampingLoose,

    freeFlowObserved: coolantFlow.freeFlowObserved,
    castingBlockageInInletConnection:
      coolantFlow.castingBlockageInInletConnection,
    castingBlockageInCylinderBlock: coolantFlow.castingBlockageInCylinderBlock,

    foundTenMMDeflection: conditionOfFanBelt.foundTenMMDeflection,
    foundVeryTight: conditionOfFanBelt.foundVeryTight,
    foundLoseFitted: conditionOfFanBelt.foundLoseFitted,

    q1001: conditionOfRadiatorPressureCap.foundOk,
    foundMissing: conditionOfRadiatorPressureCap.foundMissing,
    foundFaulty: conditionOfRadiatorPressureCap.foundFaulty,
  };

  return responseDetails;
};

export const infantCareCoolantSystem = (payload) => {
  const {
    collant,
    water,
    collantmake,
    coolantPHValue,
    percentOfCoolantOrAdditiveWithRespectToROWater,
    coolantLevelObservedInRecoveryTank,
    coolantLevelInRadiator,

    foundGood,
    foundFinsDamaged,
    foundFinsClogged,
    foundCoreLeakage,
    foundMuddyInCore,

    coolantTempratureInOC,

    q7o1,
    foundStruckOpen,
    foundStruckClosed,
    physicalDamageObserved,
    discolorationObserved,
    openingTempratureInOc,

    q8o1,
    foundCoolantLeakageFromWeepHole,
    foundCastingBlockage,

    q9o1,
    foundPunctureOrDamage,
    foundBlockage,
    foundClampingLoose,

    freeFlowObserved,
    castingBlockageInInletConnection,
    castingBlockageInCylinderBlock,

    foundTenMMDeflection,
    foundVeryTight,
    foundLoseFitted,

    q1001,
    foundMissing,
    foundFaulty,
  } = payload;

  let requestPayload = {};

  if (collant || water) {
    requestPayload.inRadiatorIsFilledWith = { collant, water };
  }

  if (collantmake) {
    requestPayload.collantmake = collantmake;
  }

  if (coolantPHValue) {
    requestPayload.coolantPHValue = coolantPHValue;
  }
  if (percentOfCoolantOrAdditiveWithRespectToROWater) {
    requestPayload.percentOfCoolantOrAdditiveWithRespectToROWater =
      percentOfCoolantOrAdditiveWithRespectToROWater;
  }

  if (coolantLevelObservedInRecoveryTank) {
    requestPayload.coolantLevelObservedInRecoveryTank =
      coolantLevelObservedInRecoveryTank;
  }
  if (coolantLevelInRadiator) {
    requestPayload.coolantLevelInRadiator = coolantLevelInRadiator;
  }

  if (
    foundGood ||
    foundFinsDamaged ||
    foundFinsClogged ||
    foundCoreLeakage ||
    foundMuddyInCore
  ) {
    requestPayload.radiatorCondition = {
      foundGood,
      foundFinsDamaged,
      foundFinsClogged,
      foundCoreLeakage,
      foundMuddyInCore,
    };
  }

  if (coolantTempratureInOC) {
    requestPayload.coolantTempratureInOC = coolantTempratureInOC;
  }

  if (
    q7o1 ||
    foundStruckOpen ||
    foundStruckClosed ||
    physicalDamageObserved ||
    discolorationObserved ||
    openingTempratureInOc
  ) {
    requestPayload.thermostatCondition = {
      foundOk: q7o1,
      foundStruckOpen,
      foundStruckClosed,
      physicalDamageObserved,
      discolorationObserved,
    };
    if (openingTempratureInOc > 0) {
      requestPayload.thermostatCondition.openingTempratureInOc =
        +openingTempratureInOc;
    }
  }

  if (q8o1 || foundCoolantLeakageFromWeepHole || foundCastingBlockage) {
    requestPayload.waterPumpCondition = {
      foundOk: q8o1,
      foundCoolantLeakageFromWeepHole,
      foundCastingBlockage,
    };
  }

  if (q9o1 || foundPunctureOrDamage || foundBlockage || foundClampingLoose) {
    requestPayload.coolantHoseCondition = {
      foundOk: q9o1,
      foundPunctureOrDamage,
      foundBlockage,
      foundClampingLoose,
    };
  }

  if (
    freeFlowObserved ||
    castingBlockageInInletConnection ||
    castingBlockageInCylinderBlock
  ) {
    requestPayload.coolantFlow = {
      freeFlowObserved,
      castingBlockageInInletConnection,
      castingBlockageInCylinderBlock,
    };
  }

  if (foundTenMMDeflection || foundVeryTight || foundLoseFitted) {
    requestPayload.conditionOfFanBelt = {
      foundTenMMDeflection,
      foundVeryTight,
      foundLoseFitted,
    };
  }

  if (q1001 || foundMissing || foundFaulty) {
    requestPayload.conditionOfRadiatorPressureCap = {
      foundOk: q1001,
      foundMissing,
      foundFaulty,
    };
  }
  const cleanedPayload = removeUndefinedFields(requestPayload);
  return cleanedPayload;
};
